import { render, staticRenderFns } from "./subscribes.vue?vue&type=template&id=2d5e22c0&"
import script from "./subscribes.vue?vue&type=script&lang=js&"
export * from "./subscribes.vue?vue&type=script&lang=js&"
import style0 from "./subscribes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d5e22c0')) {
      api.createRecord('2d5e22c0', component.options)
    } else {
      api.reload('2d5e22c0', component.options)
    }
    module.hot.accept("./subscribes.vue?vue&type=template&id=2d5e22c0&", function () {
      api.rerender('2d5e22c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/pages/account/subscribes.vue"
export default component.exports